import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Calendar, ArrowRight, Leaf, Recycle, Trash2, Heart } from 'lucide-react';
interface Series {
  id: string;
  title: string;
  description: string;
  status: 'active' | 'completed';
  icon: React.ElementType;
  color: string;
}
const seriesData: Series[] = [{
  id: '1',
  title: 'HPSN 2025',
  description: 'Hari Peduli Sampah Nasional 2025. Atasi Sampah Plastik dengan Cara Produktif.',
  status: 'active',
  icon: Calendar,
  color: 'bg-primary-100 text-primary-600'
}, {
  id: '2',
  title: 'Ramadhan Minim Sampah',
  description: 'Gerakan nasional mengurangi sampah makanan dan kemasan selama bulan suci Ramadhan.',
  status: 'active',
  icon: Leaf,
  color: 'bg-green-100 text-green-600'
}, {
  id: '3',
  title: 'Pilah Sampah dari Rumah',
  description: 'Panduan lengkap dan toolkit untuk memulai pemilahan sampah organik dan anorganik.',
  status: 'active',
  icon: Trash2,
  color: 'bg-blue-100 text-blue-600'
}, {
  id: '4',
  title: 'Ekonomi Sirkular',
  description: 'Membangun rantai nilai ekonomi dari pengelolaan sampah yang berkelanjutan.',
  status: 'active',
  icon: Recycle,
  color: 'bg-orange-100 text-orange-600'
}, {
  id: '5',
  title: 'Cegah Sampah Plastik',
  description: 'Kampanye pengurangan penggunaan plastik sekali pakai di pasar tradisional dan ritel.',
  status: 'active',
  icon: Trash2,
  color: 'bg-red-100 text-red-600'
}, {
  id: '6',
  title: 'Kompos Rumah Tangga',
  description: 'Tutorial dan pendampingan pembuatan kompos skala rumah tangga dengan metode sederhana.',
  status: 'completed',
  icon: Heart,
  color: 'bg-amber-100 text-amber-600'
}];
export function SeriesTematikPage() {
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans" data-id="element-4997">
      <Header data-id="element-4998" />

      <main className="flex-1" data-id="element-4999">
        {/* Hero Section */}
        <section className="bg-secondary-700 text-white py-16" data-id="element-5000">
          <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-5001">
            <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-5002">
              Series Tematik KIE Nasional
            </h1>
            <p className="text-lg text-secondary-100 max-w-2xl mx-auto" data-id="element-5003">
              Kumpulan program dan kampanye prioritas nasional untuk edukasi
              pengelolaan sampah yang terintegrasi.
            </p>
          </div>
        </section>

        {/* Series Grid */}
        <section className="py-12 container mx-auto px-4 md:px-6" data-id="element-5004">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-5005">
            {seriesData.map(series => <Card key={series.id} className="flex flex-col h-full hover:shadow-lg transition-shadow duration-300" data-id="element-5006">
                <div className="h-48 bg-gray-100 relative overflow-hidden flex items-center justify-center" data-id="element-5007">
                  <div className={`w-full h-full flex items-center justify-center ${series.color}`} data-id="element-5008">
                    <series.icon className="h-16 w-16 opacity-80" data-id="element-5009" />
                  </div>
                  <div className="absolute top-4 right-4" data-id="element-5010">
                    <Badge variant={series.status === 'active' ? 'success' : 'secondary'} data-id="element-5011">
                      {series.status === 'active' ? 'Aktif' : 'Selesai'}
                    </Badge>
                  </div>
                </div>
                <CardHeader data-id="element-5012">
                  <CardTitle className="text-xl font-bold text-gray-900 line-clamp-1" data-id="element-5013">
                    {series.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-1" data-id="element-5014">
                  <p className="text-gray-600 line-clamp-3" data-id="element-5015">
                    {series.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-0" data-id="element-5016">
                  <Link to={`/series/${series.id}`} className="w-full" data-id="element-5017">
                    <Button className="w-full bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 hover:text-primary-600 hover:border-primary-200 group" data-id="element-5018">
                      Lihat Series
                      <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-5019" />
                    </Button>
                  </Link>
                </CardFooter>
              </Card>)}
          </div>
        </section>
      </main>

      <Footer data-id="element-5020" />
    </div>;
}